import Component from '@bythepixel/component-loader';
import gsap from 'gsap';
import { selectors, masterTimelineOptions } from './config';
import tweens from './tweens';

export default class ImageSpinner extends Component {
  static selector = '[data-comp-image-spinner]';

  images;
  masterTimeline;
  startDelay;

  constructor(containerEl) {
    super(containerEl);
    this.masterTimeline = gsap.timeline(masterTimelineOptions);
    this.images = containerEl.querySelectorAll(selectors.image);
    this.startDelay = parseInt(containerEl.dataset.compImageSpinnerStartDelay);

    this.mount();
  }

  #createTimeline() {
    const duration = 0.5;
    const nextTimelineOverlap = `-=${duration}`;

    const options = {
      onStart: () => {
        this.masterTimeline.add(this.#createTimeline(), nextTimelineOverlap);
      },
      defaults: {
        duration,
        ease: 'power2',
      }
    };

    const timeline = gsap.timeline(options);

    this.images.forEach((image, index) => {
      const isFirstImage = index === 0;

      // -=80% --> 80% overlap with previous slideOut tween
      // +=2.5 --> 2.5 seconds after slideIn tween
      const slideInTweenPosition = isFirstImage ? 0 : '-=80%';
      const slideOutTweenPosition = '+=2.5';

      timeline
        .to(image, {
          ...tweens.slideIn,
          onStart: () => {
            image.dataset.animating = true;
            const nextImage = this.images[index + 1];

            if (!nextImage) return;

            this.#loadImage(nextImage);
          }
        }, slideInTweenPosition)
        .to(image, {
          ...tweens.slideOut,
          onComplete: () => {
            image.dataset.animating = false;
          }
        }, slideOutTweenPosition);
    });

    return timeline;
  }

  #loadImage(imgElement) {
    const imgPath = imgElement.dataset.src;

    if (!imgPath) return;

    imgElement.src = imgPath;
    imgElement.removeAttribute('data-src');
  }

  animate() {
    this.masterTimeline.add(this.#createTimeline());
  }

  mount() {
    setTimeout(this.animate.bind(this), this.startDelay);
  }
}
